import { unsafeCoerce } from 'fp-ts/lib/function';
import { NonEmpty } from './NonEmpty';

/**
 *  @returns the last item of an array.
 *
 * If the array is provably non-empty, then the result will also be provably defined.
 * If the array might be empty, then the result might be undefined.
 */
export const lastOf = <List extends readonly unknown[], Item extends List[number]>(
  list: List,
): List extends NonEmpty<Item[]> ? Item : Item | undefined => unsafeCoerce(list[list.length - 1]);
